import { BaseTable } from "@/components/shared/data-table";
import { InvoiceViewer } from "@/components/shared/file-viewers/invoice-viewer";
import { ServerSideDataTablePagination } from "@/components/shared/tables/server-side-table-pagination";
import { TableActionBar } from "./action-bar";
import type { ReceivablesTableInstance } from "./use-receivables-table";

export function Table(
  props: ReceivablesTableInstance & {
    selectedInvoiceId: string | null;
    onRowClick: (event: React.MouseEvent, row: any, index: number) => void;
  },
) {
  const {
    table,
    pagination,
    clickableColumns,
    columnVisibility,
    data,
    setPage,
    setLimit,
    columns,
    selectedInvoiceId,
    onRowClick,
  } = props;

  return (
    <div className="flex flex-col gap-2 h-full">
      <div className="flex flex-1 gap-2">
        <BaseTable
          table={table}
          clickableColumns={clickableColumns}
          columnVisibility={columnVisibility}
          columns={columns}
          data={data}
          onRowClick={onRowClick}
        />

        {selectedInvoiceId && (
          <div className="w-1/2 h-full rounded-md border overflow-hidden">
            <InvoiceViewer invoiceId={selectedInvoiceId} toolbar={true} />
          </div>
        )}
      </div>

      <div className="mt-0.5" />

      <ServerSideDataTablePagination
        table={table}
        totalItems={pagination.totalItems}
        currentPage={pagination.currentPage}
        totalPages={pagination.totalPages}
        pageSize={pagination.itemsPerPage}
        onPageChange={setPage}
        onPageSizeChange={setLimit}
      />

      <TableActionBar table={table} />
    </div>
  );
}
